<template>
    <div :class="this.currentPage === 'login' ? 'login-page' : ''">
        <v-container fluid>
            <v-card
                v-if="currentPage === 'login'"
                class="mx-auto pb-5 mt-5"
                style="max-width: 600px"
                rounded="lg"
                elevation="24"
                variant="elevated"
            >
                <v-toolbar
                    style="
                        background: linear-gradient(
                            90deg,
                            #3b3d4d 21%,
                            #242939
                        );
                        color: white;
                    "
                    dark
                    prominent
                    class="mb-5"
                >
                    <p class="text-h6 pl-5">Punch System Login</p>
                </v-toolbar>
                <v-row>
                    <v-col>
                        <div v-if="alert.show" class="mx-3">
                            <v-alert type="error">
                                <pre style="font-family: inherit">{{
                                    alert.message
                                }}</pre>
                            </v-alert>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        v-if="isSmallScreen"
                        cols="12"
                        class="d-flex pl-10 pr-5"
                    >
                        <v-img
                            max-height="150"
                            src="/images/DPAM_connect.png"
                            class="my-auto"
                        ></v-img>
                    </v-col>
                    <v-col v-else cols="6" class="d-flex pl-10 pr-5">
                        <v-img
                            max-height="150"
                            src="/images/DPAM_connect.png"
                            class="my-auto"
                        ></v-img>
                    </v-col>
                    <v-col class="pr-10 pl-5">
                        <form @submit.prevent="login">
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="User ID"
                                        variant="outlined"
                                        v-model="form.username"
                                        type="text"
                                        color="primary"
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-user"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-text-field
                                        label="Password"
                                        variant="outlined"
                                        v-model="form.password"
                                        :type="
                                            showPassword ? 'text' : 'password'
                                        "
                                        color="primary"
                                        :append-icon="
                                            showPassword
                                                ? 'mdi:mdi-eye'
                                                : 'mdi:mdi-eye-off'
                                        "
                                        @click:append="
                                            showPassword = !showPassword
                                        "
                                    >
                                        <template v-slot:prepend-inner>
                                            <font-awesome-icon
                                                icon="fa-solid fa-key"
                                                class="mr-1"
                                            />
                                        </template>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-btn
                                        variant="elevated"
                                        color="primary"
                                        class="w-100"
                                        type="submit"
                                        :loading="formProcessing"
                                    >
                                        Login
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </form>
                    </v-col>
                </v-row>
            </v-card>
            <div v-if="currentPage === 'home'" class="fill-height">
                <PunchSystem @showSnackbar="showSnackbar" />
            </div>
        </v-container>

        <v-snackbar
            v-model="snackbar.show"
            :text="snackbar.msg"
            :color="snackbar.color"
            timeout="3000"
        />
    </div>
</template>

<script>
import GuestLayout from "../../Layouts/GuestLayout.vue";
import { useForm } from "@inertiajs/inertia-vue3";
import axios from "axios";

import PunchSystem from "../../components/DPAM_PunchSystem/PunchSystem/PunchSystem.vue";

export default {
    layout: [GuestLayout],
    components: { PunchSystem },
    data() {
        return {
            showPassword: false,
            form: {
                username: null,
                password: null,
            },
            formProcessing: false,
            alert: {
                show: false,
                message: "",
            },
            isSmallScreen: false,
            currentPage: "login",
            snackbar: {
                show: false,
                msg: "",
                color: "",
            },
        };
    },
    beforeCreate() {
        // if (this.$page.props.auth.check)
        //     return (window.location.href = route("home"));
    },
    created() {
        this.updateScreenSize();
        window.addEventListener("resize", this.updateScreenSize);
    },

    destroyed() {
        window.removeEventListener("resize", this.updateScreenSize);
    },
    methods: {
        async login() {
            this.formProcessing = true;
            try {
                await axios
                    .post(
                        route("api.punch-system-login", {
                            UserID: this.form.username,
                            Password: this.form.password,
                        })
                    )
                    .then((res) => {
                        if (res.data === true) {
                            let msgData = {
                                msg: "Login Succesful",
                                color: "success",
                            };
                            this.showSnackbar(msgData);
                            this.currentPage = "home";
                        } else {
                            let msgData = {
                                msg: res.data,
                                color: "error",
                            };
                            this.showSnackbar(msgData);
                        }
                    })
                    .finally(() => {
                        this.formProcessing = false;
                    });
            } catch (err) {
                console.log(err);
            }

            // this.alert.message = "";
            // this.alert.show = false;
            // this.formProcessing = true;
            // axios.get("/sanctum/csrf-cookie").then((response) => {
            //     axios
            //         .post(route("login"), this.form)
            //         .then((response) => {
            //             // console.log(response.data.redirect)
            //             window.location.href = response.data.redirect;
            //         })
            //         .catch((obj) => {
            //             const status = obj.response.status;
            //             if (status === 422) {
            //                 const errors = obj.response.data.errors;
            //                 Object.keys(errors).forEach((key) => {
            //                     this.alert.message += `${errors[key][0]}\n`;
            //                 });
            //             }
            //             if (status === 400) {
            //                 this.alert.message = obj.response.data.message;
            //             }
            //             this.alert.show = true;
            //         })
            //         .finally(() => {
            //             this.formProcessing = false;
            //         });
            // });
        },
        updateScreenSize() {
            this.isSmallScreen = window.innerWidth <= 600;
        },
        showSnackbar(data) {
            this.snackbar = {
                show: true,
                msg: data.msg,
                color: data.color,
            };
        },
    },
};
</script>
<style scoped>
.login-page {
    background-image: url("/images/World-map.jpg");
    background-size: cover;
    background-position: center;
    height: 93vh;
}
:deep(.v-snackbar__content) {
    font-size: 1.25em;
    text-align: center;
}
</style>
